import React from 'react'
import moment from 'moment'

// ─── DayNames Component ─────────────────────────────────────
export default function DayNames() {
  return (
    <div className="CalendarElement__Row CalendarElement__DayNames">
      {[1, 2, 3, 4, 5, 6, 7].map((v, i) => (
        <span key={i} className="CalendarElement__DayName">
          {moment().startOf('week').add(i, 'days').format('dddd')}
        </span>
      ))}
    </div>
  )
}
